export default {
  farmsReport: "Relatório de Fazendas",
  cropsReport: "Relatório de Culturas",
  goalsAchievedReport: "Relatório de Metas Alcançadas",
  farm_upload_validation:{
    Farm_Upload_Validation: "Validação de Upload de Fazenda",
    Bulk_Upload_Field_Validation: "Validação de Campo de Upload em Massa",
    Go_Back: "Voltar",
    Input_Field: "Campo de Entrada",
    Validation_Message: "Mensagem de Validação",
    Description: "Descrição",
    Action: "Ação",
    Validate: "Validar",
    Farm_Name: "Nome da Fazenda",
    Farm_Registration_ID: "ID de Registro da Fazenda",
    Farmer_First_Name: "Primeiro Nome do Agricultor",
    Farmer_Last_Name: "Último Nome do Agricultor",
    Farmer_Registration_ID: "ID de Registro do Agricultor",
    User_Email_Address: "Endereço de E-mail do Usuário",
    Shared_Access_With: "Compartilhar Acesso Com",
    Ownership_Type: "Tipo de Propriedade",
    Goal_s: "Objetivo(s)",
    Production_Type: "Tipo de Produção",
    Certifications: "Certificações",
    Total_Farm_Size: "Tamanho Total da Fazenda (ex: 50 acres ou 20 hectares)",
    Farm_Address: "Endereço da Fazenda",
    Farm_GPS_Coordinates: "Coordenadas GPS da Fazenda (ex: 40.7128, -74.0060)",
    Country: "País",
    Province_State: "Província/Estado",
    Village_Town_City: "Vila/Cidade",
    Farm_Geofence: "Geofence da Fazenda (Polígono ou Círculo)",
    Helper_Messages: {
        Farm_Name: {
            Description: "O nome oficial da fazenda registrado nas autoridades ou conhecido publicamente.",
            Usage: "Este nome é usado para identificação e branding."
        },
        Farm_Registration_ID: {
            Description: "Um identificador único para o registro da fazenda.",
            Assignment: "Atribuído por um órgão governamental ou agrícola."
        },
        Farmer_First_Name: {
            Description: "O primeiro nome do agricultor que possui ou opera a fazenda.",
            Usage: "Este nome é usado para identificação pessoal e documentação legal.",
            Instructions_1: "Digite o primeiro nome do agricultor.",
            Instructions_2: "Evite abreviações, números ou caracteres especiais.",
            Instructions_3: "Se deixado em branco, o sistema gerará automaticamente 'Desconhecido' como o primeiro nome."
        },
        Farmer_Last_Name: {
            Description: "O sobrenome do agricultor.",
            Usage: "Este nome é usado para identificação pessoal e documentação legal.",
            Instructions_1: "Digite o sobrenome do agricultor.",
            Instructions_2: "Evite abreviações, números ou caracteres especiais.",
            Instructions_3: "Verifique se o sobrenome está incluído e formatado corretamente.",
            Instructions_4: "Se deixado em branco, o sistema gerará automaticamente 'Desconhecido' como o sobrenome."
        },
        Farmer_Registration_ID: {
            Description: "Um identificador único para o registro do agricultor.",
            Assignment: "Normalmente atribuído por um órgão regulador ou agrícola.",
            Usage: "Este ID é usado para registro formal e conformidade.",
            Instructions_1: "Digite o ID de Registro do Agricultor para evitar duplicações.",
            Instructions_2: "Certifique-se de que seja único e formatado corretamente.",
            Instructions_3: "Se deixado em branco, o sistema pedirá para você fornecê-lo para evitar criar entradas duplicadas (não obrigatório)."
        },
        User_Email_Address: {
            Description: "Este é o e-mail de um usuário que será atribuído à fazenda ou terá acesso principal à fazenda.",
            Context: "Pode ser o agricultor ou um técnico.",
            Usage: "Este e-mail é usado para comunicação, notificações e gerenciamento de conta.",
            Instructions_1: "Digite um e-mail válido (ex: exemplo@dominio.com).",
            Instructions_2: "Verifique se há erros de digitação e espaços.",
            Instructions_3: "Verifique se o formato do e-mail está correto.",
            Instructions_4: "Se deixado em branco, o sistema pedirá ao usuário para fornecer um e-mail válido (não obrigatório)."
        },
        Shared_Access_With: {
            Description: "Especifica indivíduos ou entidades com quem o acesso aos dados da fazenda é compartilhado.",
            Usage: "Permite colaboração controlada com base em papéis e responsabilidades."
        },
        Ownership_Type: {
            Description: "Indica o tipo de propriedade da fazenda.",
            Examples: "Exemplos incluem individual, parceria ou corporação.",
            Usage: "Isso é para fins legais e administrativos."
        },
        Goal_s: {
            Description: "Descreve os objetivos principais da fazenda."
        },
        Production_Type: {
            Description: "Indica a principal atividade agrícola da fazenda, como orgânica ou convencional."
        },
        Certifications: {
            Description: "Selecione certificações relacionadas à fazenda, como certificação orgânica, comércio justo ou GAP."
        },
        Total_Farm_Size: {
            Description: "Área total da fazenda (acres ou hectares). Usado para planejamento de recursos, relatórios regulatórios e análise de mercado."
        },
        Farm_Address: {
            Description: "Digite o endereço completo da fazenda, incluindo endereço da rua, cidade, estado e código postal. Usado para identificação de localização e entrega de serviços."
        },
        Farm_GPS_Coordinates: {
            Description: "Coordenadas geográficas (latitude e longitude) da localização da fazenda. Ajuda a localizar a fazenda no mapa."
        },
        Country: {
            Description: "O país onde a fazenda está localizada."
        },
        Province_State: {
            Description: "A província ou estado onde a fazenda está localizada. As opções dependem do país selecionado."
        },
        Village_Town_City: {
            Description: "A vila, cidade ou município onde a fazenda está localizada."
        },
        Farm_Geofence: {
            Description: "O mapeamento do geofence da fazenda inclui os limites da fazenda em um mapa. Define os limites da fazenda usando um geofence (polígono ou circular)."
        }
    },
    validation: {
        farmNameRequired: "Nome da fazenda é obrigatório",
        farmNameMaxLength: "O nome da fazenda deve ter menos de 50 caracteres",
        farmNameExists: "O nome da fazenda já existe",
        registrationIDRequired: "O ID de registro é obrigatório",
        registrationIDMaxLength: "O ID de registro deve ter menos de 20 caracteres",
        firstNameRequired: "O primeiro nome do agricultor é obrigatório",
        firstNameLettersOnly: "O primeiro nome deve conter apenas letras",
        lastNameRequired: "O sobrenome do agricultor é obrigatório",
        lastNameLettersOnly: "O sobrenome deve conter apenas letras",
        emailRequired: "O e-mail é obrigatório",
        emailValid: "Digite um e-mail válido (ex: exemplo@dominio.com)",
        emailNoSpaces: "O e-mail não deve conter espaços",
        sharedAccessWithRequired: "Selecione pelo menos uma entidade ou deixe em branco",
        ownershipTypeRequired: 'O tipo de propriedade é obrigatório ou será definido como "Desconhecido"',
        farmGoalsMaxLength: "Os objetivos da fazenda devem ter menos de 500 caracteres",
        productionTypeRequired: "Selecione um tipo de produção ou deixe em branco",
        certificationsRequired: "Selecione pelo menos uma certificação ou deixe em branco",
        farmSizePositive: "O tamanho da fazenda deve ser um valor numérico positivo",
        farmSizeUnit: "Especifique a unidade (ex: 50 acres ou 20 hectares)",
        farmAddressFormat: "Endereço inválido. Formato: Rua, Cidade, Estado, Código Postal",
        farmGPSCoordinatesFormat: "Coordenadas GPS inválidas. Formato: Latitude, Longitude (ex: 40.7128, -74.0060)",
        countryRequired: "O país é obrigatório",
        countryLettersOnly: "O nome do país deve conter apenas letras",
        provinceStateRequired: "A província/estado é obrigatória",
        provinceStateLettersOnly: "A província/estado deve conter apenas letras",
        villageTownCityRequired: "A vila/cidade é obrigatória",
        villageTownCityLettersOnly: "A vila/cidade deve conter apenas letras",
        farmGeofencePolygon: "Pontos de polígono inválidos. Formato: pares de Latitude, Longitude",
        farmGeofenceCircle: "Geofence inválido. Formato: Latitude, Longitude do Centro; Área em hectares"
    }
},
  selectFarmers: "Selecionar Agricultores",
  userDashboard: "Painel do Usuário",
  regions: "Regiões",
  crops: "Cultivos",
  goalsAchieved: "Metas Alcançadas",
  equipment: "Equipamento",
  pests: "Pragas",
  today: "Hoje",
  week: "Semana",
  month: "Mês",
  year: "Ano",
  listByLand: "Lista por Terreno",
  selectCrop: "Selecionar Cultura",
  farmStatistics: "Estatísticas de Fazendas",
  totalFarmerLand: "Total Terreno do Agricultor",
  filterByCrops: "Filtrar por Culturas",
  searchCrops: "Buscar Culturas",
  zones: "Zonas",
  state: "Estado",
  city: "Cidade",
  gpsLocation: "Localização GPS",
  rowsPerPage: "Linhas por página",
  farmersReport: "Relatório de Agricultores",
  farmersStatistics: "Estatísticas de Agricultores",
  avgAreaPerUnit: "Área Média em {unit}",
  'Yield/hectares': "Rendimento/Hectares",
 'Yield/acres': "Rendimento/Acres",
  'Yield/Hectares': "Rendimento/Hectares",
 'Yield/Acres': "Rendimento/Acres",
 yieldPerUnit: "Rendimento por {unit}",
 listByYield: "Lista por Rendimento",
 cropsStatistics: "Estatísticas de Culturas",
 totalYield: "Total Rendimento",
 yieldByCrops: "Rendimento por Cultura",
 cropStatistics: "Estatísticas de Culturas",
 totalArea: "Área Total",
 farmersChart: "Gráfico de Agricultores",
 totalPlantedArea: "Área Total Plantada",
 cropsName: "Nome das Culturas",
 planted: "Plantado",
  plantedArea: "Área Plantada",
  harvested: "Colhido",
  yieldAcre: "Rendimento/Ha",
  "Equipment Report": "Relatório de Equipamentos",
  selectFarmer: "Selecionar Agricultor",
  listByFarmers: "Lista por Agricultores",
  equipmentName: "Nome do Equipamento",
  region: "Região",
  counts: "Contagens",
  listByFarmer: "Listar por Agricultor",
  equipmentChart: "Gráfico de Equipamento",
  equipmentReport: "Relatório de Equipamento",
  "Goals Achieved Report": "Relatório de Metas Alcançadas",
  goalsAchievedChart: "Gráfico de Metas Alcançadas",
  successRate: "Taxa de Sucesso",
  goalsFailed: "Metas Não Alcançadas",
  buySell: {
    farmerName: "Nome do agricultor",
    location: "Localização",
    country: "País",
    gender: "Gênero",
    noOfOrdersSold: "Número de pedidos vendidos",
    noOfPurchaseOrders: "Número de ordens de compra",
    totalSellVolume: "Volume total vendido",
    totalAvgValue: "Valor médio total",
    searchOrderByID: "Buscar pedido por ID",
    totalNumberofOrders: "Número total de pedidos",
    totalNumberOfTransactions: "Número total de transações",
    totalWeightOfTransactions: "Peso total das transações",
    totalMonetaryValue: "Valor monetário total",
    averagePrice: "Preço médio"
  }, 
  plantationSettings: "Configurações de Plantação",
  addNew: "Adicionar Novo",
  uploadImage: "Carregar Imagem",
  traceability: {
    coffeeInformation: "Informações sobre o Café",
    uploadImage: "Carregar Imagem",
    originationCountry: "País de Origem",
    traceabilityImage: "Imagem de Rastreabilidade",
    traceability: "Rastreabilidade",
    coffeeTraceabilityMngmnt: "Gestão de Rastreabilidade do Café",
    traceabilityPage: "Página de Rastreabilidade",
    labelDesigner: "Designer de Etiqueta",
    additionalInformation: "Informações Adicionais",
    info1:
      "Forneça informações sobre os logotipos adicionais do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
    addSlogan: "Adicionar Slogan",
    additionalLogos: "Logotipos Adicionais",
    title: "Título",
    description: "Descrição",
    mapLink: "Link do Mapa",
    websiteLink: "Link do Website",
    addMedia: "Adicionar Mídia",
    uploadImageVideo: "Carregar Imagem/Vídeo",
    origin: "Origem",
    info2:
      "Forneça informações sobre o país de origem do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
    countryImage: "Imagem do País",
    institutionalInfo: "Informações Institucionais",
    info3:
      "Forneça informações sobre a sua empresa/cooperativa, conte aos consumidores sobre o trabalho relevante que você tem realizado. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
    cooperativeLogo: "Logotipo da Cooperativa",
    traceabilityIntro: "Introdução à Rastreabilidade",
    info4:
      "Esta seção dará ao consumidor acesso a todo o histórico de produção e processamento de café. Descreva a importância da rastreabilidade para a sua empresa/cooperativa e para o mundo.",
    addLabel: "Adicionar Etiqueta",
    chooseTitle: "Escolher Título",
    chooseLabelDesign: "Escolher Modelo de Design de Etiqueta",
    uploadYourLogo: "Carregar seu Logotipo",
    info5:
      "Instruções: O tamanho da imagem deve ser pelo menos 1000 x 1000 pixels quadrados. Você pode escolher o formato PNG transparente para combinar com as cores de fundo.",
    chooseTemplateColors: "Escolher Cores do Modelo",
    backgroundColor: "Cor de Fundo",
    foregroundColor: "Cor de Primeiro Plano",
    labelStatus: "Status da Etiqueta",
    inactive: "Inativo",
    download: "Baixar",
    enterLabelTitle: "Insira o Título da Etiqueta",
  },
  profileSetting: {
    profileAuthSettings: "Configuração de Autenticação de Perfil",
    changeSettings: "Alterar Configurações",
    loginLogoutSettings: "Configurações de Login/Logoff",
    autoLogout: "Logoff Automático",
    unsuccAtmp: "Tentativas de login malsucedidas",
    unsuccLoginLock: "Periodo de trava após login malsucedido",
    pswCrisetup: "Regras de senha",
    pswLength: "Tamanho da senha",
    noOfUniquePsw: "Numero de senhas únicas exigidos ",
    maxPswAge: "Idade máxima da senha",
    AccRangeOfchars: "Faixa de caracteres aceitável ",
    upperCase: "Maiúscula",
    lowerCase: "Minúscula",
    numbers: "Números",
    specialChars: "Caracteres Especiais",
    settingsUpdated: "Configurações atualizadas",
    settingsNotUpdated: "Configuração não atualizadas",
    selectCountry: "Selecionar País",
    selectCountryInfo: "Escolha a localização geográfica aplicável à avaliação.",
    days: "Dias",
    months: "Meses",
  },
  
  statusItems: {
    closed: "Fechado",
    open: "Abrir",
    moreInfoReq: "Mais informações necessárias",
  },
  userslist: {
    createNewUser: "Criar Novo Usuário",
    chooseCreateType: "Por favor, escolha uma das seguintes opções:",
    addNewUser: "Adicionar Novo Usuário",
    editUser: "Editar Usuário",
    addNewAdmin: "Adicionar Usuário Administrador",
    userLoading: "Carregando Usuários... Por favor, aguarde",
    noUser: "NENHUM USUÁRIO DISPONÍVEL",
    extendVal: "ESTENDER VALIDADE",
    extendReason: "Motivo da Extensão",
    extendReasonMsg: "Especifique o motivo da extensão da associação",
    exportAsCSV: "EXPORTAR COMO CSV",
    membershipType: "Tipo de Associação",
    membershipValidity: "Validade da Associação",
    regionState: "Região/Estado",
    cityTown: "Cidade/Vila",
    clearAll: "LIMPAR TUDO",
    search: "PESQUISAR",
    familyTribe: "Digite sua tribo familiar",
    enterWebsite: "Digite o site",
    registrationDate: "Data de Registro",
    single: "Solteiro",
    multiple: "Múltiplo",
    user: "Usuário",
  },
  addEdituser: {
    firstNameRequired: "O nome é obrigatório",
    firstNameOllyAlpha: "O nome deve conter apenas letras",
    firstNameLimit: "O nome deve ter menos que 50 caracteres",
    lastNameRequired: "Sobrenome é obrigatório",
    lastNameOllyAlpha: "O sobrenome só pode conter letras",
    lastNameLimit: "O sobrenome dever ter menos que 50 letras",
    emailReuired: "É necessário um e-mail",
    emailInvalid: "Formato de e-mail inválido.",
    mobileRequired: "É necessário um número de telefone",
    invalidMobile: "Formato de número inválido.",
    emailExistAlready: "O usuário já existe com este e-mail.",
    mobileExistAlready: "O usuário já existe com este número de celular.",
    pswRequired: "É necessário uma senha",
    deptRequired: "É necessário um departamento",
    roleRequired: "É necessário um perfil",
    countryRequired: "O código país é obrigatório",
    userUpdated: "Usuário Atualizado",
    userNotUpdated: "Usuário não atualizado",
    activateAct: "Ativar Conta",
    deactivateAct: "Desativar Conta",
    userActivated: "Usuário Ativado",
    userDeactivated: "Usuário Desativado",
    deactivateUser: "Desativar Usuário",
    deactivateMsg: "Tem certeza que deseja alterar o status?",
    userAdded: "Usuário Adicionado",
    userNotAdded: "Usuário Não Adicionado",
    validityUpTo: "Validity Up To",
    facilityPicture: "Facility Picture",
    editAppUser: "Editar usuário do aplicativo",
    roleEdited: "Função Editada",
    addDepartment: "Adicionar Departamento",
    editDepartment: "Editar Departamento",
    department: "Departamento",
    noDepartment: "Nenhum Departamento",
    departmentNameRequired: "Nome do departamento é obrigatório",
    departmentAdded: "Departamento Adicionado",
    departmentEdited: "Departamento Editado",
    eoriNumberRequired: "Número EORI obrigatório",
    eoriIsNumber: "EORI deve ser um número",
    addNewSupplier: "Adicionar Novo Fornecedor",
    addNewProducer: "Adicionar Novo Produtor",
    addNewOperator: "Adicionar Novo Operador",
    eoriNumber: "Número EORI"
  },
  activationKey: {
    membershipRoleFilterDesc: "Filtrar Plano de Associação por Função",
    email: "Email",
    filterBy: "Filtrar Por",
    membershipRoleFilter: "Filtro de Função de Associação",
    enterActivationKey:
      "Por favor insira a chave de ativação para registrar um novo usuário",
    activationKeyLimit: "Minimum 15 characters",
    countryRequired: "Country Code is required",
    activationKeyRequired: "Chave de ativação necessária",
    activationKey: "Chaves de ativação",
    comments: "Comentários",
    appointSalesManager: "Nomear Gerente de Vendas",
    appointManager: "NOMEAR GERENTE",
    salesManAppSuccess: "GERENTE DE VENDAS NOMEADO COM SUCESSO",
    uploadData: "CARREGAR CSV DE DADOS ATRIBUÍDOS",
    uploadUserData: "Faça o upload do arquivo de dados do usuário.",
    downloadCsv:
      "(Faça o download do arquivo .csv de amostra para manter a estrutura)",
    downloadSample: "Baixar arquivo de amostra",
    dragDrop: "Arraste e solte ou",
    browse: "Procurar",
    yourFile: "seu arquivo",
    pdfSupport: "Apenas arquivos PDF são suportados.",
    pleaseWait: "Por favor, aguarde",
    note: "Nota",
    incorectFileType: "Tipo de arquivo incorreto",
    somethingWentWrong: "Algo deu errado",
    fileUploadedSuccess: "Arquivo enviado com sucesso",
    countRecords: "Contar registros",
    sendNow: "ENVIE AGORA",
    fileName: "nome do arquivo",
    assignActKey: "Atribuindo chaves de ativação",
    actKeyAssSucc: "Chaves de ativação atribuídas com sucesso",
    viewActKey: "VER CHAVES DE ATIVAÇÃO",
    actKeyQuota: "Cota de chaves de ativação",
    genActKey: "Chaves de ativação geradas",
    remActKey: "Chaves de ativação restantes",
    penUsed: "Chaves Pendentes e Usadas",
    activationKeyAss: "Activation Keys Assigned",
    activationKeyUnass: "Chaves de ativação atribuídas",
    keysAct: "Chaves ativadas",
    uploadedFiles: "Arquivos enviados",
    generateActKey: "GERAR CHAVES DE ATIVAÇÃO",
    showData: "Mostrar dados",
    noDataFound: "Nenhum dado encontrado",
    pleaseGenKey:
      'Gere as chaves de ativação usando o "Gerar Chaves de Ativação"',
    noActKey: "Nenhuma chave de ativação gerada",
    buttonAbv: "botão acima",
    numberOfActKey: "Número de chaves de ativação",
    membershipRole: "Função de membro",
    membershipPlan: "Planos de associação",
    genKeys: "GERAR CHAVES",
    keysNum: "Número das Chaves",
    phoneNumber: "Número de telefone",
    keysStatus: "Status das Chaves",
    ActivationKeysList: "Lista de chaves de ativação",
    back: "Voltar",
    usingActKeys: 'usando o "Gerar Chaves de Ativação"',
    pleaseGenActKeyss: "Gere a chave de ativação",
    clearAllFilters: "LIMPAR TODOS OS FILTROS",
    salesManager: "Gerente de vendas",
    clearAll: "LIMPAR TUDO",
    generatedBy: "Gerado por",
    numberOfKeys: "Número de Chaves",
    action: "Ação",
    viewAllUplFiles: "Ver todos os arquivos enviados",
    bulkUploadUsers: "Carregar usuários em massa",
    noActivationKeyFound: "Nenhuma chave de ativação encontrada",
    pleaseCreateAdminRole:
      "Por favor, crie uma função de administrador usando o",
    btnCreateAdmin: 'botão "Criar função de administrador" acima',
    donwloadAsCsv: "Baixar como CSV",
    donwloadAsPdf: "Baixe como PDF",
    assignSalesManager: "Atribuir gerente de vendas",
    shareViaEmail: "Compartilhar por e-mail",
    sendEmail: "ENVIAR EMAIL",
    emailSend: "E-MAIL ENVIADO COM SUCESSO",
    donwload: "Download",
    deleteFile: "Excluir arquivo",
    invalidFileData: "Os dados da chave de ativação no arquivo são inválidos",
    continue: "Continuar",
    description: "Descrição",
    selectWeek: "Selecionar Semana",
    confirm: "CONFIRME",
    selectMonth: "Selecione o mês",
    selectDateRange: "Selecionar intervalo de datas",
    regionDistrict: "Região/distrito",
    address: "Endereço",
    familyTribe: "Comunidade",
    website: "Site",
    deactivated: "Inativo",
    active: "Ativo",
    country: "País",
    farmer: "Produtor",
    commodity: "Mercadoria",
    quantity: "Quantidade",
    unit: "Unidade",
    price: "Preço",
    save: "SALVAR",
    stateIsReq: "O estado é obrigatório",
    cityIsReq: "A cidade é obrigatória",
    addressIsReq: "Address is required",
    membershipTypeReq: "Membership type is required",
    extendedReasonReq: "Extend reason is required",
    numberOfDaysReq: "Number of days is required",
    extendedMembershipValidity: "Validade estendida do plano",
    set: "SET",
    adminRole: "Funções de administrador",
    typeMsg: "Type your message here",
    errors: {
      cannotBeBlank: "Este campo não pode estar vazio",
      required: "Este campo é obrigatório",
      somethingWentWrong: "Algo deu errado!!!",
    },
    loadingData: "Carregando dados...",
    markAsRead: "Marcar como Lido",
    membership: {
      remainingDays: "Número de dias restantes",
      type: "Tipo de Plano",
      validity: "Validade do Plano",
      validityLength: {
        custom: "Personalizado",
        expired: "Expirado",
        oneTo8Months: "1-8 months",
        lessThan1Month: "1-8 meses",
        moreThan1Month: "Mais de 1 ano",
        sixTo12Months: "6-12 meses",
      },
    },
    of: "do",
    ok: "OK",
    statusItems: {
      closed: "Fechado",
      open: "Abrir",
    },
    orderByItems: {
      all: "Tudo",
      dateAscending: "Data Crescente",
      dateDescending: "Data Decrescente",
      dueDate: "Data de vencimento",
      high: "Alto",
      low: "Baixo",
      medium: "Médio",
    },
    orderBy: "Ordenar por",
    select: "Selecionar",
    type: "Tipo",
    uploadImageVideo: "Carregar imagens/vídeos",
    user: "Usuários",
    userName: "Nome de Usuário",
    usersSelected: "Usuário selecionado",
    topics: "Tópicos",
    date: "Encontro",
    addNew: "Adicionar novo",
    exportAsCsv: "Exportar como CSV",
    noData: "Nenhum dado encontrado",
    login: {
      welcomeMsg: "Bem Vindo! Conecte-se",
      info: "Insira suas credenciais.",
      forgot: "Forgot Password?Esqueceu a Senha?",
      btn: "Conecte-se",
      unableToLogin: "Não foi possível entrar",
    },
    forgot: {
      info_l1:
        "Por favor insira o e-mail associado à sua conta. Detalhes sobre a senha serão enviados ao seu e-mail.",
      info_l2:
        "Por favor insira o número de celular associado com a sua conta. Detalhes sobre a senha serão enviados ao seu celular.",
      info_l3:
        "Please choose one of the following options to receive instructions on how to reset your password",
      forgotQ: "Esqueceu sua senha?",
      loginNow: "Entrar",
      resetSucc: "Sua senha foi redefinida com sucesso",
      resetSucc_l2:
        "Você já pode utilizar sua nova senha para acessar sua conta.",
      entPsw: "Digite sua nova senha.",
      resetPsw: "Redefina sua senha",
      resendOTP: "Reenviar Código",
      enterCorrectOTP: "Insira o código correto.",
      enterOTP: "Insira o código recebido por e-mail/celular.",
      backToLoginPage: "Voltar para a página de login",
      recieveCodeFalse: " I didn't receive the code",
    },
    dashboard: "Painel",
    mainDashboard: "Painel Principal",
    userDashboard: "Painel do Usuário",
    userslist: {
      createNewUser: "Criar Novo Usuário",
      chooseCreateType: "Por favor, escolha uma das seguintes opções:",
      addNewUser: "Adicionar Novo Usuário",
      editUser: "Editar Usuário",
      addNewAdmin: "Adicionar Usuário Administrador",
      userLoading: "Carregando Usuários... Por favor, aguarde",
      noUser: "NENHUM USUÁRIO DISPONÍVEL",
      extendVal: "ESTENDER VALIDADE",
      extendReason: "Motivo da Extensão",
      extendReasonMsg: "Especifique o motivo da extensão da associação",
      exportAsCSV: "EXPORTAR COMO CSV",
      membershipType: "Tipo de Associação",
      membershipValidity: "Validade da Associação",
      regionState: "Região/Estado",
      cityTown: "Cidade/Vila",
      clearAll: "LIMPAR TUDO",
      search: "PESQUISAR",
      familyTribe: "Digite sua tribo familiar",
      enterWebsite: "Digite o site",
      registrationDate: "Data de Registro",
      single: "Solteiro",
      multiple: "Múltiplo",
      user: "Usuário",
    },
   
    permissions: {
      savePermissions: "SALVAR PERMISSÕES",
      moduleName: "Nome do módulo",
      view: "Visualizar",
      create: "Crear",
      update: "Atualizar",
      delete: "Deletar",
      permissionsUpdated: "Permissões Atualizadas",
      permissionsNotUpdated: "Permissões não atualizadas",
      selectMembership: "Selecionar plano",
      noPermMsg:
        'Selecione o tipo de Plano usando o menu suspenso "Tipo de Plano" acima para visualizar suas permissões',
      selectRoleMsg: "Selecione a função acima para mostrar as permissões",
    },
    logs: {
      time: "Horário",
      username: "Nome de Usuário",
      role: "RolPerfile",
      terminalID: "Id do Terminal",
      moduleAccessed: "Módulo Acessado",
      typeOfAccess: "Tipo de Acesso",
      activityLogDetails: "Detalhes da Atividade",
      userId: "ID do Usuário",
      lastLogin: "Ultimo Login",
      geoAccPoint: "Geographical access point",
      ipAdd: "IP address",
      filesAccessed: "Files accesLocal de acessosed",
      funAccessed: "Função Acessada",
      webUrl: "Endereço da Pagina",
      unsuccAtmp: "Tentativas de login malsucedida",
      view: "Visualizar",
      membershipType: "Tipo de Plano",
    },
    profileSetting: {
      profileAuthSettings: "Configuração de Autenticação de Perfil",
      changeSettings: "Alterar Configurações",
      loginLogoutSettings: "Configurações de Login/Logoff",
      autoLogout: "Logoff Automático",
      unsuccAtmp: "Tentativas de login malsucedidas",
      unsuccLoginLock: "Periodo de trava após login malsucedido",
      pswCrisetup: "Regras de senha",
      pswLength: "Tamanho da senha",
      noOfUniquePsw: "Numero de senhas únicas exigidos ",
      maxPswAge: "Idade máxima da senha",
      AccRangeOfchars: "Faixa de caracteres aceitável ",
      upperCase: "Maiúscula",
      lowerCase: "Minúscula",
      numbers: "Números",
      specialChars: "Caracteres Especiais",
      settingsUpdated: "Configurações atualizadas",
      settingsNotUpdated: "Configuração não atualizadas",
      selectCountry: "Selecionar País",
    },
    dashboardSection: {
      greenBeansData: "Gestão de Feijão Verde",
      dryMilling: "Moagem a Seco",
      modules: "Módulos",
      allowances: "Subsídios",
      maxUserAllowed: "Máximo de usuários permitidos ",
      satelliteReportsAllowed: "Relatórios de satélite permitidos ",
      advanceReport: "Relatórios avançados permitidos",
      subscriptionUpTo: "Assinatura até",
      roleAllowed: "Funções permitidas ",
      moduleAllowed: "Módulos permitidos ",
      registeredUsers: "Usuários registrados",
      validMemberships: "Associações válidas",
      activeUsers: "Usuários ativos",
      deactivatedUsers: "Usuários desativados",
      membershipValidity: "Validade da associação",
      lessThan1Month: "Menos de 1 mês",
      months1to6: "1-6 meses",
      months6to12: "6-12 meses",
      moreThan1Year: "Mais de 1 ano",
      cropOverview: "Visão geral do Cultivo",
      plantations: "Plantações ",
      coffeeData: "Dados do café",
      availableModules: "Módulos disponíveis",
      roleList: "Agricultor, Estação de Coleta, Armazém",
      memberData: "Dados de Membro",
      userType: "Tipo de Usuário",
      registered: "Registrado",
      offlineUsers: "Usuários Offline",
      lessThanOneMonth: "< 1 Mês",
      cacaoData: "Dados de Cacau",
      dryCacao: "Cacau Seco",
      traceability: "Rastreabilidade",
      allFarm: "Todas as Fazendas",
    },
    adminRoles: {
      adminRoles: "Funções de administrador",
      roleName: "Nome doa função",
      description: "Descrição",
      viewPermissions: "Ver permissões",
      createAdminRole: "CRIAR FUNÇÃO DE ADMINISTRADOR",
      enterDesHere: "Digite sua descrição aqui",
      deleteRole: "Excluir função",
      deleteMsg: "Tem certeza de que deseja excluir a função?",
      roleReq: "O nome da função é obrigatório",
      roleLimit: "O nome da função deve ter menos de 15 caracteres",
      desReq: "A descrição é obrigatória",
      desLimit: "A descrição deve ter 40 caracteres ou menos",
      roleSuccess: "Função criada com sucesso",
      editAdminRole: "Editar função de administrador",
      roleUpdated: "Função atualizada",
      noRole: "Nenhuma função de administrador encontrada",
      noRoleMsg:
        "Crie uma função de administrador usando o botão 'Criar função de administrador' acima",
    },
    membershipplanSection: {
      defaultPlan: " Alterar plano padrão",
      planType: "Tipo de plano",
      planDuration: "Duração do Plano",
      planFee: "Taxa do plano",
      satelliteReport: "Relatórios de satélite",
      advanceReport: "Relatórios avançados",
      addMembership: "Adicionar associação",
      addMembershipPlan: "Adicionar plano de associação",
      editMembershipPlan: "Editar plano de associação",
      accessSetelite:
        "Acesso a relatórios de satélite (conjunto de 5 relatórios)",
      accessAdvanceReport: "Acesso a relatórios avançados",
      memPlanReq: "O plano de associação é obrigatório",
      memPlanReqLimit: "O plano de associação deve ter menos de 20 caracteres",
      SatelliteReq: "O Relatório de Satélite é obrigatório",
      advancedReportReq: "O relatório avançado é obrigatório",
      durationReq: "A duração do plano é obrigatória",
      feeReq: "A taxa de adesão é necessária",
      cantLesThenZero: "Não pode ser menor que 0",
      roleReq: "A função do usuário é obrigatória",
    },
    tickets: {
      actions: {
        create: "Criar Tikcet",
        delete: "Excluir Chamado",
        edit: "Editar Chamado",
      },
      areaOfRequest: "Área de solicitação",
      assignee: "Cessionário",
      deleteTicket: {
        confirmation: "Tem certeza de que deseja excluir o{0} ticket?",
      },
      dueDate: "Data de vencimento",
      filters: {
        ticketFor: "Ticket para",
      },
      form: {
        ticketType: {
          admin: "Criar ticket para o Administrador Dimitra",
          user: "Criar ticket para usuário do aplicativo",
        },
      },
      markAsRead: "Marcar como Lido",
      messages: {
        created: {
          success: "Chamado criado com sucesso",
        },
        deleted: {
          success: "Chamado excluído com sucesso",
        },
      },
      noData: "Nenhum Chamado encontrado!",
      noDataHelpText: `Você ainda não tem tickets atribuídos a{0}você. Clique no botão "Criar Ticket"{1}na parte superior desta tela para começar.`,
      pickerInMenu: "Seletor no menu",
      priority: {
        high: "Alto",
        label: "Prioridade",
      },
      reply: "Responder",
      requestedDateTime: "Data e hora de soliticação",
      requestorDetails: "Detalhes do solicitante",
      requestorEmail: "E-mail do solicitante",
      subject: "Assunto",
      ticketsForItems: {
        all: "Tudo",
        dimitraAdmin: "Administrador Dimitra",
        multipleUsers: "Vários usuários",
        singleUser: "Usuário Único",
      },
      title: "Tikcet",
    },
    roleRequest: {
      roleRequest: "Solicitação de função",
      userRole: "Papel do usuário",
      approve: "Aprovar",
      reject: "Rejeitar",
      username: "Nome de usuário",
      email: "E-mail",
      phone: "Celular",
      roleAssigned: "Função atribuída",
      roleRequested: "Função solicitada",
      requestedDate: "Data de solicitação",
      updateRoleRequest: "Atualizar solicitação de função",
      message: "mensagem",
      update: "Atualizar",
    },
    faqSection: {
      createFaq: "Criar pergunta frequente",
      createTopic: "Criar tópico",
      selectTopic: "Selecionar tópico",
      faqQuestion: "Pergunta frequente",
      faqAnswer: "Resposta de perguntas frequentes",
      uploadImgVid: "Carregar imagem/vídeo do anúncio",
      disInFaq: "Exibir na seção de perguntas frequentes",
      editFaq: "Editar perguntas frequentes",
      topicName: "Nome do tema",
      parentTopic: "Tema Principal",
      editTopic: "Editar tópico",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",
    },
    reports: {
      usersByStatus: "Usuários por Status",
      farmerName: "Nome do agricultor",
      farmerProdChart: "Gráfico de Produção do Agricultor",
      production: "Produção",
      byProduction: "Por Produção",
      byName: "Por nome",
      descending: "Decrescente",
      ascending: "Crescente",
      buyingStationProdChart: "Gráfico de Produção da Estação de Coleta",
      buyingStation: "Estação de coleta",
      buyingStationName: "Nome da estação de coleta",
      dryMilling: "Moagem a Seco",
      dryMillingName: "Nome de moagem a seco",
      dryMillingProdChart: "Tabela de Produção de Moagem a Seco",
      view: "Visualizar",
      date: "Encontro",
      reports: "Relatórios",
      weight: "Peso",
      quality: "Qualidade",
      price: "Preço",
      gen: "Gênero",
      gender: "Gráfico de Gênero",
      male: "Masculino",
      female: "Feminino",
      other: "Outro",
      unspecified: "Não Especificado",
      byCountry: "Por País",
      avgPriceFarmer: "Preço Médio Pago Por Agricultor (Cacau)",
      avgPrice: "Preço Médio",
      selectYear: "Selecionar Ano",
      total: "Total",
      today: "Hoje",
      week: "Semana",
      month: "Mês",
      year: "Ano",
      all: "Todos",
      selectCrop: "Selecionar Cultura",
      selectRegion: "Selecionar Região",
      selectProvinceState: "Selecionar Província/Estado",
      downloadPdfReport: "Baixar Relatório PDF",
      export: "Exportar",
      search: "Buscar",
      yield: "Rendimento",
      averageSellingPriceByAllFarmers:
        "Preço Médio de Venda por Todos os Agricultores",
      averageSellingPricePerFarmer: "Preço Médio de Venda por Agricultor",
      pricePaid: "Preço Pago",
      pests: {
        pestReport: "Relatório de Pragas",
        filterByCrops: "Filtrar por Culturas",
        pestStatistics: "Estatísticas de Pragas",
        regions: "Regiões",
        occurrences: "Ocorrências",
        pestChart: "Gráfico de Pragas",
        totalArea: "Área Total",
        pestName: "Nome da Praga",
        region: "Região",
        crop: "Culturas",
        listByLand: "Lista por Terreno",
      },
      regions: {
        regionalReport: "Relatório Regional",
        listByFarm: "Lista por Fazenda",
        listByFarmers: "Lista por Agricultores",
        listByYield: "Lista por Rendimento",
        regionalStatistics: "Estatísticas Regionais",
        countries: "Países",
        states: "Estados/Províncias",
        city: "Cidade/Vila",
        farmsIn: "Fazendas em",
        regionalChart: "Gráfico Regional",
        farms: "Fazendas",
        regionName: "Nome da Região",
        farmers: "Agricultores",
        yield: "Rendimento/Acre",
      },
    },
    traceability: {
      coffeeInformation: "Informações sobre o Café",
      uploadImage: "Carregar Imagem",
      originationCountry: "País de Origem",
      traceabilityImage: "Imagem de Rastreabilidade",
      traceability: "Rastreabilidade",
      coffeeTraceabilityMngmnt: "Gestão de Rastreabilidade do Café",
      traceabilityPage: "Página de Rastreabilidade",
      labelDesigner: "Designer de Etiqueta",
      additionalInformation: "Informações Adicionais",
      info1:
        "Forneça informações sobre os logotipos adicionais do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
      addSlogan: "Adicionar Slogan",
      additionalLogos: "Logotipos Adicionais",
      title: "Título",
      description: "Descrição",
      mapLink: "Link do Mapa",
      websiteLink: "Link do Website",
      addMedia: "Adicionar Mídia",
      uploadImageVideo: "Carregar Imagem/Vídeo",
      origin: "Origem",
      info2:
        "Forneça informações sobre o país de origem do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
      countryImage: "Imagem do País",
      institutionalInfo: "Informações Institucionais",
      info3:
        "Forneça informações sobre a sua empresa/cooperativa, conte aos consumidores sobre o trabalho relevante que você tem realizado. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
      cooperativeLogo: "Logotipo da Cooperativa",
      traceabilityIntro: "Introdução à Rastreabilidade",
      info4:
        "Esta seção dará ao consumidor acesso a todo o histórico de produção e processamento de café. Descreva a importância da rastreabilidade para a sua empresa/cooperativa e para o mundo.",
      addLabel: "Adicionar Etiqueta",
      chooseTitle: "Escolher Título",
      chooseLabelDesign: "Escolher Modelo de Design de Etiqueta",
      uploadYourLogo: "Carregar seu Logotipo",
      info5:
        "Instruções: O tamanho da imagem deve ser pelo menos 1000 x 1000 pixels quadrados. Você pode escolher o formato PNG transparente para combinar com as cores de fundo.",
      chooseTemplateColors: "Escolher Cores do Modelo",
      backgroundColor: "Cor de Fundo",
      foregroundColor: "Cor de Primeiro Plano",
      labelStatus: "Status da Etiqueta",
      inactive: "Inativo",
      download: "Baixar",
      enterLabelTitle: "Insira o Título da Etiqueta",
    },
    cacaoTraceability: {
      traceability: "Rastreabilidade",
      cacaoTraceabilityMngmnt: "Gestão de Rastreabilidade do Cacau",
      traceabilityPage: "Página de Rastreabilidade",
      labelDesigner: "Designer de Etiqueta",
      additionalInformation: "Informações Adicionais",
      info1:
        "Forneça informações sobre os logotipos adicionais do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do cacau.",
      addSlogan: "Adicionar Slogan",
      additionalLogos: "Logotipos Adicionais",
      title: "Título",
      description: "Descrição",
      mapLink: "Link do Mapa",
      websiteLink: "Link do Website",
      addMedia: "Adicionar Mídia",
      uploadImageVideo: "Carregar Imagem/Vídeo",
      origin: "Origem",
      info2:
        "Forneça informações sobre o país de origem do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do cacau.",
      countryImage: "Imagem do País",
      institutionalInfo: "Informações Institucionais",
      info3:
        "Forneça informações sobre a sua empresa/cooperativa, conte aos consumidores sobre o trabalho relevante que você tem realizado. Essas informações estarão disponíveis ao público na página de rastreabilidade do cacau.",
      cooperativeLogo: "Logotipo da Cooperativa",
      traceabilityIntro: "Introdução à Rastreabilidade",
      info4:
        "Esta seção dará ao consumidor acesso a todo o histórico de produção e processamento de cacau. Descreva a importância da rastreabilidade para a sua empresa/cooperativa e para o mundo.",
      addLabel: "Adicionar Etiqueta",
      chooseTitle: "Escolher Título",
      chooseLabelDesign: "Escolher Modelo de Design de Etiqueta",
      uploadYourLogo: "Carregar seu Logotipo",
      info5:
        "Instruções: O tamanho da imagem deve ser pelo menos 1000 x 1000 pixels quadrados. Você pode escolher o formato PNG transparente para combinar com as cores de fundo.",
      chooseTemplateColors: "Escolher Cores do Modelo",
      backgroundColor: "Cor de Fundo",
      foregroundColor: "Cor de Primeiro Plano",
      labelStatus: "Status da Etiqueta",
      inactive: "Inativo",
      download: "Baixar",
      enterLabelTitle: "Insira o Título da Etiqueta",
    },
    setting: {
      profileAuthSetting: "Configuração de Autenticação de Perfil",
      logInOutSetting: "Configurações de Login/Logoff",
      autoLogout: "Logoff Automático",
      unsuccessfulLoginAttempt: "Unsuccessful Login Attemps",
      unsuccessfulLoginLockPeriod: "Tentativas malsucedidas de login",
      passCriteriaSetup: "Regras de senha",
      passLength: "Tamanho da senha",
      noUniquePassRequired: "Numero de senhas únicas exigidos",
      maxPassAge: "Idade máxima da senha",
      acceptableRangeOfChars: "Faixa de caracteres aceitável",
      upperCase: "Maiúscula",
      lowerCase: "Minúscula",
      numbers: "Números",
      specialChars: "Caracteres Especiais",
      uniqueSymbols: "Simbolos Únicos",
      loadingData: "Carregando dados...",
      currency: "Moeda",
      codeActivationTime: "Tempo de ativação do código",
      changeGlobalSetting: "Alterar configurações globais",
      globalSetting: "Alterar configurações globais",
      generalSetting: "Configurações Gerais",
      hour: "Horas",
      days: "Dias",
      minutes: "Minutos",
      perDay: "Por dia",
      perHour: "Por hora",
      customised: "Personalizado",
    },
    coffeeData: {
      windBreaker: "Árvore quebra-vento",
      horticultureInfo: "Árvore de horticultura",
      shadeTree: "Árvore de sombra",
      coffeeVariety: "Variedade de café",
      coffeeSpecies: "Espécies de café",
      updateWindBreaker: "Atualizar tipo de árvore quebra-vento",
      addWindBreaker: "Adicionar novo tipo de árvore quebra vento",
      updateHorticultureInfo:
        "Atualizar informações de tipo de árvore na horticultura",
      addHorticultureInfo:
        "Adicionar novas informações de tipo de árvore na horticultura",
      updateShadeTree: "Atualizar tipo de árvore de sombra",
      addShadeTree: "Adicionar novo tipo de árvore para sombra",
      updateCoffeeVariety: "Atualizar tipo de árvore coffeeVariety",
      addCoffeeVariety: "Adicione o novo tipo de árvore à variedade de café",
      deleteVarietyTitle: "Excluir variedade",
      deleteVarietyMessage: "Tem certeza de que deseja excluir a variedade?",
      updateCoffeeSpecie: "Atualizar espécie de café",
      deleteSpecieTitle: "Excluir espécie",
      deleteSpecieMessage: "Tem certeza de que deseja excluir Espécie?",
      addCoffeeSpecie: "Adicionar nova espécie de café",
      variety: "Variedade",
      selectVariety: "Selecionar variedade",
      deleteCoffeeRecord: "Tem certeza de que deseja excluir o registro?",
      deleteCoffeeData: "Excluir dados de café",
      topicRequired: "O nome do tópico é obrigatório",
      coffeeAddSuccess: "Espécie de café adicionada com sucesso.",
      treeTypeSuccess: "Tipo de árvore adicionado com sucesso..",
      treeTypeUpdateSuccess: "Tipo de árvore atualizado com sucesso.",
      coffeeVarietySuccess: "Variedade de café adicionada com sucesso.",
      coffeeSpecieSuccess: "Espécie de café atualizada com sucesso.",
      nameRequired: "O nome é obrigatório",
      notFound: "Nenhum dado do Admin encontrado.",
    },
    cacaoData: {
      cacao: "Cacau",
      cacaoOverview: "Visão Geral do Cacau",
      cacaoVariety: "Variedade de Cacau",
      cacaoSpecies: "Espécie de Cacau",
      deleteCacaoData: "Excluir Dados de Cacau",
    },
    plantation: {
      farmerName: "Nome do agricultor",
      phoneNumber: "Número de telefone",
      plantationName: "Nome da plantação",
      farm: "Propriedade",
      location: "Localização",
      updatePlantationStatus: "Atualizar Status da Plantação",
      update: "Atualizar",
    },
    surveyBuilder: {
      addNewSurvey: "Adicionar Nova Pesquisa",
      surveyTitle: "Título da Pesquisa",
      surveyName: "Nome da Pesquisa",
      surveyDescription: "Descrição da Pesquisa",
      describeSurvey: "Descreva a Pesquisa",
      enableScheduling: "Ativar Agendamento",
      enableSchedulingInfo: "Capacidade de definir uma data ou hora específica para a avaliação.",
      selectedDate: "Data Selecionada",
      multiStepSurvey: "Pesquisa em Múltiplas Etapas",
      multiStepSurveyDetails:
        "Com base no número de perguntas em uma etapa, todas as perguntas da pesquisa serão agrupadas e exibidas em etapas.",
      multiStep: "Múltiplas Etapas",
      noQuestionEachStep: "Número de perguntas em cada etapa",
      surveyStatus: "Status da Pesquisa",
      surveyStatusDetails:
        "A pesquisa só pode ser ativada após a adição de perguntas. Ativar uma pesquisa permitirá que os agricultores comecem a enviar respostas.",
      selectUsers: "Selecionar Usuários",
      selectUsersDetails:
        "Se a opção 'Selecionar Usuário' estiver desabilitada, a pesquisa estará disponível para todos os usuários. Se você habilitar a seleção de usuários, poderá escolher vários usuários na próxima etapa.",
      linkWithFarms: "Vincular às Fazendas",
      linkWithFarmsDetails:
        "Se habilitado, a pesquisa será vinculada às fazendas individuais. Se um agricultor tiver várias fazendas, cada fazenda terá sua própria pesquisa.",
      enabled: "Ativado",
      disabled: "Desativado",
      cancel: "Cancelar",
      next: "Próximo",
      surveySettings: "Configurações da Pesquisa",

      selectSurveyUsers: "Selecionar Usuários da Pesquisa",
      selectToProceed: "Por favor, selecione usuário(s) para prosseguir",
      searchUsers: "Buscar Usuários",
      usersSelected: "Usuários Selecionados",
      conditional: "Condicional",
      autoConditional: "Condicional Automática",
      userName: "Nome de Usuário",
      email: "E-mail",
      membershipType: "Tipo de Associação",
      membershipValidity: "Validade da Associação",
      membershipRemainingDays: "Número de Dias Restantes",
      membershipRole: "Função de Membro",
      accountProgress: "Progresso da Conta",
      status: "Status",
      active: "Ativo",
      inactive: "Inativo",
      deactivated: "Desativado",
      continue: "Continuar",
      questions: "Perguntas",
      questionInfo: "O texto da pergunta de avaliação que será apresentada ao respondente.",
      responses: "Respostas",
      deleteSurvey: "Excluir Pesquisa",
      editSurvey: "Editar Pesquisa",
      type: "Tipo",
      compulsory: "Obrigatório",
      createSurvey: "Criar Pesquisa",
      surveyBuilder: "Construtor de Pesquisas",
      surveyList: "Lista de Pesquisas",
      farm: "Fazenda",
      responseDate: "Data da Resposta",
      viewSurvey: "Visualizar Pesquisa",
      question: "Pergunta",
      settings: "Configurações",
      addQuestion: "Adicionar Pergunta",
      surveysSubmitted: "Pesquisas Enviadas",
      surveyDetail: "Detalhes da Pesquisa",
      conditionStatus: "Status da Condição",
      conditionStatusDesc:
        "Usuários que correspondem às condições se tornarão automaticamente elegíveis para a pesquisa.",

      endSurvey: "Encerrar Pesquisa",
      publishSurvey: "Publicar Pesquisa",
      copy: "Copiar",
      view: "Visualizar",
      startDate: "Data de Início",
      endDate: "Data de Término",
      chooseDate: "Escolher data",
      select: "Selecionar",
      addSurveyQuestion: "Adicionar Pergunta da Pesquisa",
      editSurveyQuestion: "Editar Pergunta da Pesquisa",
      questionScore: "Pontuação da Pergunta",
      mandatory: "Obrigatória",
      yes: "Sim",
      no: "Não",
      options: "Opções",
      typeHere: "Digite aqui",
      typeInfo: "Um menu suspenso para especificar o tipo de entrada necessária para a pergunta, como botão de opção, caixa de seleção ou entrada de texto.",
      add: "Adicionar",
      optionsHint:
        "Por favor, pressione Enter para adicionar uma resposta ou clique em Adicionar",
      surveyProgress: "Pesquisa em progresso",
      allResponses: "Resumo de Todas as Respostas",
      responseQuestion: "Respostas por Pergunta",
      dateSubmitted: "Data de Envio",
      answer: "Respostas",
      totalScore: "Pontuação Total",
      score: "Pontuação",
      singleSelection: "Seleção Única",
      multipleSelection: "Seleção Múltipla",
      if: "Se",
      then: "então",
      noResponse: "Sem resposta",
      noSurveyFound: "Nenhuma Pesquisa Encontrada",
      createNewSurvey:
        'Por favor, crie uma pesquisa usando o botão "Criar Pesquisa" acima',
      cannotPublish: "Não é possível publicar uma pesquisa desabilitada!",
      deleteSurveyWarn:
        "Você tem certeza de que deseja excluir a pesquisa? Se você a excluir, todas as perguntas e respostas da pesquisa serão excluídas permanentemente.",
      noQuestionFound: "Nenhuma Pergunta Encontrada",
      createQuestion:
        'Por favor, adicione uma pergunta primeiro usando o botão "ADICIONAR PERGUNTAS" acima',
      deleteQuestion: "Tem certeza de que deseja excluir a pergunta?",
      applyChanges: "Como você gostaria de aplicar essas mudanças?",
      editFutureSurveys: "EDITAR APENAS PESQUISAS FUTURAS",
      editLiveSurveyOnly: "EDITAR APENAS PESQUISA ATIVA",
      surveyIsLive:
        "Por favor, note que a pesquisa está atualmente ativa, e editar uma pergunta neste momento pode afetar envios anteriores. Para evitar problemas, você pode considerar criar uma cópia da pesquisa para fazer alterações nas perguntas.",
      clickToCopy: "Clique Aqui Para Criar uma Cópia da Pesquisa",
      applyChangesNow: "APLICAR MUDANÇAS AGORA",
      copySurvey: "Copiar Pesquisa",
      changeCopySurveyName:
        "Você pode alterar o nome da versão copiada da pesquisa.",
    },
    memberDataSection: {
      import: "Importar",
      buyingStation: "Estação de Compra",
      continue: "Continuar",
      farmerId: "ID do Agricultor",
      farmerName: "Nome do Agricultor",
      farmerAddress: "Endereço do Agricultor",
      quality: "Qualidade",
      quantity: "Quantidade",
      importAll: "Importar Tudo",
      importSelected: "Importar Selecionado",
      fileLoaded: "Arquivo carregado com sucesso",
      incorrectHeaders: "Cabeçalhos incorretos",
      processingBatch: "Processando Lote",
      purchaseOrder: "Ordem de Compra",
      startDate: "Data de Início",
      endDate: "Data de Término",
      purchasingOrder: "Ordem de Compra",
      totalCoffeeCherry: "Total de Cerejas de Café",
      airHumidity: "Umidade do Ar",
      density: "Densidade",
      temperature: "Temperatura",
      beanMoistureContent: "Conteúdo de Umidade do Grão",
      processType: "Tipo de Processo",
      batchRating: "Selecionar Avaliação do Lote",
      purchaseDate: "Data de Compra",
      selectFarmer: "Selecionar Agricultor",
      selectFarm: "Selecionar Fazenda",
      selectPlantation: "Selecionar Plantação",
      coffeeVariety: "Variedade de Café",
      coffeeSpecies: "Espécie de Café",
      coffeeCherryQuantity: "Quantidade de Cerejas de Café",
      coffeeCherryQuality: "Qualidade de Cerejas de Café",
      coffeeType: "Tipo de Café",
      pricePerKg: "Preço Por Kg",
      processingDone: "Processamento Concluído",
      processedCoffeeOut: "Café Processado Entregue",
      farmer: "Agricultor",
      farm: "Fazenda",
      plantation: "Plantação",
      farmers: "Agricultores",
      farmLimitUsed: "Limite de Fazenda Utilizado",
      phoneNumber: "Número de Telefone",
      farmSize: "Tamanho da Fazenda",
      farmLocation: "Fazenda/Localização",
      date: "Data",
      status: "Status",
      noFarmers: "Nenhum Agricultor Encontrado",
      approveReject: "Aprovar/Rejeitar",
      farms: "Fazendas",
      crops: "Cultivos",
      equipment: "Equipamento",
      noFarms: "Nenhuma Fazenda Encontrada",
      views: "Visualizar",
      selectStatus: "Selecionar Status",
      approved: "Aprovado",
      rejected: "Rejeitado",
      reject: "Rejeitar",
      approve: "Aprovar",
      cancel: "Cancelar",
      add: "Adicionar",
      describeYourReason: "Descreva sua razão aqui",
      userInformation: "Informação do Usuário",
      userFarmRequest: "Solicitação de Fazenda do Usuário",
      userFarmInformation: "Informação de Fazenda(s) do Usuário",
      activity: "Atividade",
      activityType: "Tipo de Atividade",
      farmZone: "Zona da Fazenda",
      farmerView: "Visão do Agricultor",
      cropType: "Tipo de Cultivo",
      cropVariety: "Variedade de Cultivo",
      area: "Área",
      cost: "Custo",
      geofence: "Geocerca",
      map_views: "Visão de Mapa",
      viewAllFarms: "Ver Todas as Fazendas",
      farmersDetails: "Detalhes do Agricultor",
      download: "Baixar",
      pOrder: {
        addNew: "Adicionar Novo",
        viewAll: "Ver Tudo",
        selectDate: "Selecionar data",
        makeSelection: "Fazer uma seleção",
        coffeeType: "Tipo de café",
        enterPrice: "Inserir preço",
        reqPurchaseDate: "A data de compra é obrigatória",
        reqFarmer: "O agricultor é obrigatório",
        reqCoffeeQnty: "A Quantidade de Cerejas de Café é obrigatória",
        reqPrice: "O Preço Por Kg é obrigatório",
        grandTotal: "TOTAL GERAL",
        selectDateRange: "Selecionar Intervalo de Datas",
        import: "Importar",
        purchaseId: "ID de Compra",
        purchaseDate: "Data de Compra",
        farmerName: "Nome do Agricultor",
        quality: "Qualidade",
        quantity: "Quantidade",
        pricePerKg: "Preço por Kg",
        selectBuyingStation: "Selecionar estação de compra",
        searchUser: "Buscar Usuários",
      },
    },
    cropsReport: "Relatório de Culturas",
    today: "Hoje",
    week: "Semana",
    month: "Mês",
    year: "Ano",
    all: "Todos",
    cropsStatistics: "Estatísticas de Culturas",
    crops: "Culturas",
    acres: "Acres",
    totalPlantedArea: "Área Total Plantada",
    farmersChart: "Gráfico de Agricultores",
    cropsName: "Nome das Culturas",
    farmers: "Agricultores",
    farms: "Fazendas",
    planted: "Plantado",
    plantedArea: "Área Plantada",
    harvested: "Colhido",
    yieldAcre: "Rendimento/Acre",
    selectCrop: "Selecionar Cultura",
    listByYield: "Listar por Rendimento",
    listByPlantedArea: "Listar por Área Plantada",
    equipmentReport: "Relatório de Equipamento",
    equipmentChart: "Gráfico de Equipamento",
    selectFarmer: "Selecionar Agricultor",
    selectFarmers: "Selecionar Agricultores",
    equipmentName: "Nome do Equipamento",
    region: "Região",
    counts: "Contagens",
    large: "Grande",
    medium: "Médio",
    small: "Pequeno",
    listByFarmer: "Listar por Agricultor",
    rowsPerPage: "Linhas por Página",
    farmersReport: "Relatório de Agricultores",
    farmersStatistics: "Estatísticas de Agricultores",
    averageFarmerLand: "Média de Terra por Agricultor",
    largeFarmers: "Agricultores Grandes",
    mediumFarmers: "Agricultores Médios",
    smallFarmers: "Agricultores Pequenos",
    listByLand: "Listar por Terra",
    listByFarm: "Listar por Fazenda",
    AvgLandAcre: "Média de Terra/Acre",
    listbyCrop: "Listar por Cultura",
    listbyZone: "Listar por Zona",
    farmName: "Nome da Fazenda",
    zones: "Zonas",
    area: "Área",
    goalsAchievedReport: "Relatório de Metas Alcançadas",
    listByCrops: "Listar por Culturas",
    goalsAchievedChart: "Gráfico de Metas Alcançadas",
    goalsAchieved: "Metas Alcançadas",
    goalsFailed: "Metas Não Alcançadas",
    successRate: "Taxa de Sucesso",
    achieved: "Alcançadas",
    equipment: "Equipamento",
    pests: "Pragas",
    regions: "Regiões",
    filterByCrops: "Filtrar por Culturas",
    searchCrops: "Buscar Culturas",
    batchCode: "Código de Lote",
    batchRating: "Classificação de Lote",
    MakeASelection: "Faça uma Seleção",
    typeTotalCoffeeQuantity: "Digite a Quantidade Total de Café",
    typeHumidity: "Digite a Umidade",
    valueInPercent: "Valor em Porcentagem",
    purchaseOrderRequired: "Ordem de Compra Obrigatória",
    totalCoffeeCherryRequired: "Quantidade Total de Cereja de Café Obrigatória",
    processTypeRequired: "Tipo de Processo Obrigatório",
    stationInfo: "Informações da Estação",
    purchaseOrders: "Ordens de Compra",
    processingBatch: "Lote de Processamento",
    processedCoffeeOutRequired: "Café Processado Obrigatório",
    lotNo: "Número do Lote",
    addNewS: "Adicionar Novo",
    viewAll: "Ver Todos",
    parchmentOut: "Pergaminho Saindo",
    processingDone: "Processamento Concluído",
    farmerLotID: "ID do Agricultor e Lote",
    weight: "Peso",
    plantationSettings: "Configurações de Plantação",
    PlantationsEachFarmerCanCreate:
      "Número de Plantações que Cada Agricultor Pode Criar",
    manageAdditionalPlantationRequests:
      "Gerenciar Pedidos de Plantação Adicionais",
    autoApprove: "Aprovação Automática",
    adminApprovalRequired: "Aprovação do Administrador Obrigatória",
    close: "Fechar",
    new_user: "Novo Usuário",
    KGAcre: "KG/Acre",
    pending: "Pendente",

    "Farmer Name": "Nome do Agricultor",
    "Goals Achieved": "Metas Alcançadas",
    "Goals Failed": "Metas Não Alcançadas",
    "Success Rate": "Taxa de Sucesso",

    "Equipment Name": "Nome do Equipamento",
    Region: "Região",
    Farmer: "Agricultor",
    Counts: "Contagens",

    "Pest Name": "Nome da Praga",
    "Total Area": "Área Total",
    Crop: "Cultivo",

    "Crop Name": "Nome do Cultivo",
    Farmers: "Agricultores",
    Farms: "Fazendas",
    Planted: "Plantado",
    "Planted Area": "Área Plantada",
    Harvested: "Colhido",
    "Yield/acre": "Rendimento por Acre",
    "Region Name": "Nome da Região",

    "Avg. Land/Acre": "Média de Terra por Acre",
    Crops: "Cultivos",
    "Yield/area": "Rendimento/área",
    "Avg. land/Acre": "Média de terra/Acre",

    "Farm Name": "Nome da Fazenda",
    Zones: "Zonas",
    Area: "Área",

    "Goals Achieved Report": "Relatório de Metas Alcançadas",
    "Farms Report": "Relatório de Fazendas",
    "Pest Report": "Relatório de Pragas",
    "Equipment Report": "Relatório de Equipamentos",
    "Crops Report": "Relatório de Culturas",
    "Farmers Report": "Relatório de Agricultores",
    "Regional Report": "Relatório Regional",
  },

  ownershipTypes: {
    EXW: "EXW (Na Fábrica)",
    FCA: "FCA (Transportador Livre)",
    CPT: "CPT (Transporte Pago Até)",
    CIP: "CIP (Transporte e Seguro Pagos Até)",
    DAP: "DAP (Entregue no Local)",
    DPU: "DPU (Entregue no Local Descarregado)",
    DDP: "DDP (Entregue com Direitos Pagos)",
    FAS: "FAS (Livre ao Lado do Navio)",
    FOB: "FOB (Livre a Bordo)",
    CFR: "CFR (Custo e Frete)",
    CIF: "CIF (Custo, Seguro e Frete)"
  },
  
  membership: {
    remainingDays: "Número de Dias Restantes",
    type: "Tipo de Associação",
    validity: "Validade da Associação",
    validityLength: {
      custom: "Personalizado",
      expired: "Expirado",
      oneTo8Months: "1-8 meses",
      lessThan1Month: "Menos de 1 mês",
      moreThan1Month: "Mais de 1 ano",
      sixTo12Months: "6-12 meses",
    },
    areaOfRequest: "Área da Solicitação",
    assignee: "Responsável",
    deleteTicket: {
      confirmation: "Tem certeza de que deseja excluir o ticket {0}?",
    },
    dueDate: "Data de Vencimento",
    filters: {
      ticketFor: "Ticket Para",
    },
    form: {
      ticketType: {
        admin: "Criar Ticket para Administrador da Dimitra",
        user: "Criar Ticket para Usuário do Aplicativo",
      },
    },
    markAsRead: "Marcar como lido",
    messages: {
      created: {
        success: "Ticket criado com sucesso",
      },
      deleted: {
        success: "Ticket excluído com sucesso",
      },
    },
    noData: "Nenhum Ticket Encontrado!",
    noDataHelpText: `Você ainda não possui nenhum ticket atribuído a {0} você. Clique no botão "Criar Ticket" {1} no topo desta tela para começar.`,
    pickerInMenu: "Seletor no menu",
    priority: {
      high: "Alta",
      label: "Prioridade",
    },
    reply: "Responder",
    requestedDateTime: "Data e Hora Solicitadas",
    requestorDetails: "Detalhes do Solicitante",
    requestorEmail: "Email do Solicitante",
    subject: "Assunto",
    ticketsForItems: {
      all: "Todos",
      dimitraAdmin: "Administrador da Dimitra",
      multipleUsers: "Múltiplos Usuários",
      singleUser: "Usuário Único",
    },
    title: "Tickets",
  },
  
  roleRequest: {
    roleRequest: "Solicitação de Função",
    userRole: "Função do Usuário",
    approve: "Aprovar",
    reject: "Rejeitar",
    username: "Nome de Usuário",
    email: "Email",
    phone: "Telefone",
    roleAssigned: "Função Atribuída",
    roleRequested: "Função Solicitada",
    requestedDate: "Data da Solicitação",
    updateRoleRequest: "Atualizar Solicitação de Função",
    message: "Mensagem",
    update: "Atualizar",
  },
}